var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2176 14.4029H1.68722C1.48773 14.4029 1.29641 14.4822 1.15535 14.6232C1.01429 14.7643 0.935046 14.9556 0.935046 15.1551C0.935046 15.3546 1.01429 15.5459 1.15535 15.687C1.29641 15.828 1.48773 15.9073 1.68722 15.9073H12.2176C12.4171 15.9073 12.6084 15.828 12.7495 15.687C12.8906 15.5459 12.9698 15.3546 12.9698 15.1551C12.9698 14.9556 12.8906 14.7643 12.7495 14.6232C12.6084 14.4822 12.4171 14.4029 12.2176 14.4029ZM1.68722 12.8986H1.75491L4.89147 12.6128C5.23506 12.5785 5.55642 12.4272 5.8016 12.184L12.5711 5.41448C12.8339 5.13691 12.9759 4.76649 12.966 4.38441C12.9562 4.00233 12.7952 3.63974 12.5185 3.3761L10.4575 1.31515C10.1886 1.06249 9.83609 0.917517 9.46718 0.907809C9.09827 0.898101 8.73867 1.02433 8.45677 1.26249L1.68722 8.03204C1.44409 8.27723 1.29271 8.59858 1.25848 8.94217L0.935046 12.0787C0.924914 12.1889 0.939209 12.2999 0.976913 12.404C1.01462 12.508 1.0748 12.6024 1.15318 12.6805C1.22346 12.7502 1.30681 12.8053 1.39845 12.8428C1.4901 12.8802 1.58823 12.8992 1.68722 12.8986ZM9.41203 2.36819L11.4655 4.42162L9.96111 5.88835L7.94529 3.87253L9.41203 2.36819Z",
    fill: "#A9876F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e5cba4fdf1167113bf2aba66f526e5f4.svg";
export { ForwardRef as ReactComponent };